import { AuthSurface } from "@/components/auth/types";

import { PatientSource } from "@/types/enums/patient-source";

import { useSelfScheduleStore } from "@/stores/self-schedule-store";

/** `?source=` tag on a sign-up link opened from self-scheduling. */
export const SELF_SCHEDULE_SIGNUP_SOURCE = "self_schedule";

/** Patient source for a sign-up that started on `surface`, if it has one. */
export function patientSourceForSurface(
  surface: AuthSurface | undefined,
): PatientSource | undefined {
  return surface === AuthSurface.SELF_SCHEDULE
    ? PatientSource.SELF_SCHEDULING
    : undefined;
}

/** Patient source for the sign-up page, from its `?source=` tag. */
export function patientSourceForSignUpTag(
  tag: string | null,
): PatientSource | undefined {
  return tag === SELF_SCHEDULE_SIGNUP_SOURCE
    ? PatientSource.SELF_SCHEDULING
    : undefined;
}

/** `?locationId=` on a sign-up link opened from self-scheduling. */
export const SIGN_UP_LOCATION_PARAM = "locationId";

/**
 * The location a self-scheduling sign-up was booking at. The sign-up link
 * carries it because the sign-up page is a full navigation, and an embedded
 * browser may not keep the booking flow's stored selection across it; the
 * store is the fallback for sign-ups that never leave the booking page. Lets a
 * visitor who signs up but never books still show which location they came for.
 */
export function signUpLocationId(
  patientSource: PatientSource | undefined,
  linkedLocationId?: string | null,
): string | undefined {
  if (patientSource !== PatientSource.SELF_SCHEDULING) return undefined;
  return (
    linkedLocationId ||
    useSelfScheduleStore.getState().selectedLocationId ||
    undefined
  );
}
